/**
 * Application's resources storage
 *
 * @class ResourceLocator
 * @extends Backbone.Model
 */
export class ResourceLocator extends Backbone.Model {

}


// WEBPACK FOOTER //
// ./js/resources/ResourceLocator.js